/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Judge_Call_BtnInputs */



/**
* | output |
* | --- |
* | "Call Judge" |
*
* @param {Judge_Call_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const judge_call_btn = /** @type {((inputs?: Judge_Call_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Judge_Call_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appeler l'arbitre")
	if (locale === "es") return /** @type {LocalizedString} */ ("Llamar al juez")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Chamar juiz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiama il giudice")
	return /** @type {LocalizedString} */ ("Call Judge")
});